import { defineMessages } from 'react-intl';

const messages = defineMessages({
  altImgLogo: { id: 'modules-auth-contentLayout-altImgLogo' },
  logoLinkTitle: { id: 'modules-auth-contentLayout-logoLinkTitle' },
});

export default messages;
